export default __webpack_public_path__ + "static/media/mail.d074a325.svg";